// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { getExams } from "../api";
import { ExamType } from "../types";

export const useExamsData = (
  clinicId: string | undefined,
  patientId: string | undefined
) => {
  const { getToken } = useTokenAccess();

  return useQuery<Array<ExamType>>({
    queryKey: ["exams", clinicId, patientId],
    queryFn: async () => {
      if (!clinicId || !patientId) throw new Error();
      const token = await getToken();
      const controller = new AbortController();
      return getExams(token, clinicId, patientId, controller.signal);
    },
    refetchOnWindowFocus: false,
    structuralSharing: false,
    staleTime: 5 * 60 * 1000, // optional: cache for 5 minutes
  });
};
